<template>
  <div class="table-pagination">
    <div class="current">
      <label>{{ tablePagination.rowsPerPageLabel }}:</label>
      <select v-model.number="currentPerPage" @change="changePerPage">
        <option v-for="option in perPageOptions" :key="option" :value="option">{{ option }}</option>
      </select>
    </div>

    <div class="actions">
      <span>{{ from }} - {{ to }} de {{ total }}</span>
      <div class="buttons">
        <div class="btn-action" :class="canGoPrev ? 'active' : 'not-active'" @click="prevPage" :disabled="!canGoPrev">
          ◀ {{ tablePagination.prevLabel }}
        </div>
        <div class="btn-action" :class="canGoNext ? 'active' : 'not-active'" @click="nextPage" :disabled="!canGoNext">
          {{ tablePagination.nextLabel }} ▶
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configData from "../config";

export default {
  mixins: [configData],
  props: ['_options'],
  data() {
    return {
      currentPage: Number(this._options.currentPage),
      currentPerPage: Number(this._options.currentPerPage),
      from: this._options.from,
      perPageOptions: [10, 50, 100, 500],
      to: this._options.to,
      total: this._options.total,
      tablePagination: configData.tablePagination,
    };
  },
  computed: {
    canGoNext() {
      return this.currentPage * this.currentPerPage < this.total;
    },
    canGoPrev() {
      return this.currentPage > 1;
    }
  },
  watch: {
    _options: {
      handler(newVal) {
        if (!newVal) return;
        this.currentPage = Number(newVal.currentPage) || this.currentPage;
        this.currentPerPage = Number(newVal.currentPerPage) || this.currentPerPage;
        this.from = newVal.from !== undefined ? newVal.from : this.from;
        this.to = newVal.to !== undefined ? newVal.to : this.to;
        this.total = newVal.total !== undefined ? newVal.total : this.total;
      },
      deep: true
    }
  },
  methods: {
    changePerPage() {
      this.currentPage = 1; // sempre reinicia na página 1 ao trocar por página
      this.emitPagination();
    },
    nextPage() {
      if (this.canGoNext) {
        this.currentPage++;
        this.emitPagination();
      }
    },
    prevPage() {
      if (this.canGoPrev) {
        this.currentPage--;
        this.emitPagination();
      }
    },
    emitPagination() {
      const paginationOptions = {
        currentPage: this.currentPage,
        currentPerPage: this.currentPerPage,
        from: this.from,
        to: this.to,
        total: this.total
      };
      this.$emit('paginate', { options: paginationOptions });
    }
  }
};
</script>

<style scoped>
/* estilos opcionais */
</style>
